// extracted by mini-css-extract-plugin
export default {"linkInBtn":"link__linkInBtn___ahwHa","primary":"link__primary___IJwP_","secondary":"link__secondary___ZEkPK","defaultLink":"link__defaultLink___CvuT1"};